var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"lock-scroll",rawName:"v-lock-scroll.skip",modifiers:{"skip":true}}],staticClass:"gift_list_wp"})}
var staticRenderFns = []

export { render, staticRenderFns }